/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import AccordionControl from 'app/components/common/AccordionControl.jsx';
import classnames from 'classnames';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import ListModule from 'app/mixins/ListModule.js';
import AdvancedRouteItemDetail from 'app/components/RouteList/AdvancedRouteItemDetail.jsx';
import * as _ from 'underscore';
import { compose } from 'redux';
import { Breakpoint } from 'react-socks';
import SocialAvatar from 'app/components/common/SocialAvatar.jsx';


class AdvancedRouteItem extends React.Component {
	constructor(props) {
		super(props);

		this.onDetailClick = this.onDetailClick.bind(this);

	}

	componentDidMount() {

        if (this.props.showDetail) {
			let element = document.getElementById(`route-${this.props.route.id}`);
			if (element) {
				let pos = element.getBoundingClientRect().top;
				window.scrollTo({
					top: (pos + window.pageYOffset) - 125,
					behavior: "instant"
				});
			}

        }

    }

	onDetailClick(event) {
		this.props.detailHandler(event);
	}

	render() {
		let inactive = (parseInt(this.props.route.activeFlag, 10) === 1) ? false : true,
			itemClass = classnames(
				'dlvr-list-item',
				'advanced',
				{
					'detail': (this.props.showDetail) ? true : false,
					'inactive': inactive,
					'blur': (this.props.showDetail && this.props.routeDetail === null) ? true : false
				}
			),
			itemNameClass = classnames(
				'item-input-label advanced',
				{
					'inactive': inactive
				}
			),
			statusClass = classnames(
				'route-status',
				{
					'inactive': inactive
				}
			),
			dividerClass = classnames(
				'icon ion-forward',
				{
					'detail': (this.props.routeDetail !== null) ? true : false
				}
			),
			socialLabelClass = classnames(
				'item-social-label',
				{
					'inactive': inactive
				}
			),
			itemStatusClass = classnames(
				'item-status-label', 'advanced',
				{
					'inactive': inactive
				}
			),
			InputIcon = null,
			OutputIcons = null,
			RouteDetail = null,
			status = null,
			errors = false,
			constants = this.props.app.config.constants,
			iconInactive = false,
			IconTemp = null,
			IconTemp2 = null,
			accordionOpen = false;

		for (let i = 0; i < this.props.route.inputs.length; ++i) {
			if (parseInt(this.props.route.inputs[i].postFlag, 10) === constants.POST_QUEUE) {
				dividerClass = classnames(
					'ds-icon icon-queue',
					{
						'detail': (this.props.showDetail) ? true : false
					}
				);
				break;
			}
		}

		for (let i = 0; i < this.props.route.inputs.length; ++i) {
			if (parseInt(this.props.route.inputs[i].repostFlag, 10)) {
				if (dividerClass.match('queue')) {
					dividerClass = classnames(
						'ds-icon icon-replay-queue',
						{
							'detail': (this.props.routeDetail !== null) ? true : false
						}
					);
				} else {
					dividerClass = classnames(
						'icon ion-reply-all',
						{
							'detail': (this.props.routeDetail !== null) ? true : false
						}
					);
				}
			}
		}

		const iconGenerator = (input) => {
			let icon = null;

			if (input) {
				if (input.icon !== undefined && input.icon) {
					icon = (
						<SocialAvatar
							input={input}
							compact={true}
							showCompactName={true}
							inactive={inactive}/>
					);
				} else {
					icon = (
						<IconFactory.feed inactive={inactive} round={true}/>
					);
				}
			}

			return icon;
		}

		if (this.props.route.inputs.length === 1) {
			InputIcon = (
				<div>
					<Breakpoint mobile only>
						<div className="item-icon-wrapper">
							{iconGenerator(this.props.route.inputs[0])}
							<span className={socialLabelClass + " badge"}>
								1
							</span>
						</div>
					</Breakpoint>
					<Breakpoint desktop only>
						<div className="item-icon-wrapper">
							{iconGenerator(this.props.route.inputs[0])}
						</div>
						<span className={socialLabelClass}>
							1 Feed
						</span>
					</Breakpoint>
				</div>
			);
		} else {
			InputIcon = (
				<div>
					<Breakpoint mobile only>
						<div className="item-icon-wrapper">
							{iconGenerator(this.props.route.inputs[0])}
							<span className={socialLabelClass + " badge"}>
								{this.props.route.inputs.length}
							</span>
						</div>
					</Breakpoint>
					<Breakpoint desktop only>
						<div className="item-icon-wrapper">
							{iconGenerator(this.props.route.inputs[0])}
						</div>
						<span className={socialLabelClass}>
							{this.props.route.inputs.length} Feeds
						</span>
					</Breakpoint>
				</div>
			);
		}

		OutputIcons = this.props.getOutputIcons(this.props.route.outputs, inactive);

		status = this.props.setStatus(this.props.route.activeFlag, this.props.route.lastPost.postTs);
		statusClass = classnames(
			'item-row-cell status',
			status.className,
			{
				'inactive': inactive
			}
		);

		if (this.props.showDetail) {
			accordionOpen = true;
			RouteDetail = (
				<AdvancedRouteItemDetail
					{...this.props}
					route={this.props.route}
					routeHandler={this.props.routeHandler}
					newRouteInfo={this.props.newRouteInfo}
					messages={this.props.messages}
					errorCount={this.props.route.errCount}
					recordPath={this.props.recordPath}
					inputRefreshHandler={this.props.inputRefreshHandler} />
			);
		}

		return (
			<li className={itemClass} id={`route-${this.props.route.id}`}>
				<Breakpoint desktop only>
					<div className="list-item-row" onClick={this.props.detailHandler} data-id={this.props.route.id} role="switch" aria-label="show detail">
						<AccordionControl accordionOpen={accordionOpen} />
						<div className="item-row-cell input-label advanced">
							<div className={itemNameClass} alt={this.props.route.name} title={this.props.route.name}>
								{this.props.route.name}
							</div>
						</div>
						<div className="item-row-cell advanced-inputs">
							{InputIcon}
						</div>
						<div className="item-row-cell item-divider">
							<i className={dividerClass}></i>
						</div>
						<div className="item-row-cell social">
							{OutputIcons}
						</div>
						<div className={statusClass}>
							<span className={itemStatusClass}>
								{status.label}
							</span>
							<span className="item-status-icon">
								{status.icon}
							</span>
						</div>
					</div>
				</Breakpoint>
				<Breakpoint mobile only>
					<div className="list-item-row" onClick={this.props.detailHandler} data-id={this.props.route.id} role="switch" aria-label='show detail'>
						<div className="item-row-cell advanced-inputs">
							{InputIcon}
						</div>
						<div className="item-row-cell item-divider">
							<i className={dividerClass}></i>
						</div>
						<div className="item-row-cell input-label advanced">
							<div className={itemNameClass} alt={this.props.route.name} title={this.props.route.name}>
								{this.props.route.name}
							</div>
						</div>
						<div className={statusClass}>
							<span className={itemStatusClass}>
								{status.label}
							</span>
							<span className="item-status-icon">
								{status.icon}
							</span>
						</div>
					</div>
				</Breakpoint>
				{RouteDetail}
			</li>
		);
	}
}

AdvancedRouteItem.propTypes = {
	detailHandler: PropTypes.func,
	route: PropTypes.object,
	routeHandler: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.object
	]),
	newRouteInfo: PropTypes.object,
	showDetail: PropTypes.bool,
	messages: PropTypes.array,
	recordPath: PropTypes.func,
	inputRefreshHandler: PropTypes.func,
};

AdvancedRouteItem.defaultProps = {
	detailHandler: null,
	route: {},
	routeHandler: null,
	newRouteInfo: {},
	showDetail: false,
	messages: [],
	recordPath: null,
	inputRefreshHandler: null
};

export default ListModule(AdvancedRouteItem);
